import React, { useEffect, useState } from "react";
import { FaCog } from "react-icons/fa";
import SignInModes from "./SignIn";
import SignInLegacy from "./SignInLegacy";
import { loadSignInModesEnabled } from "../helpers/signInModes";

// Picks the sign-in page from the public `signInModes` flag; a failed or slow fetch keeps legacy.
const SignInRoute = () => {
  const [signInModes, setSignInModes] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    loadSignInModesEnabled({ signal: controller.signal }).then((enabled) => {
      if (!controller.signal.aborted) setSignInModes(enabled);
    });
    return () => controller.abort();
  }, []);

  if (signInModes === null) {
    return (
      <div className="protected-route-loading" role="status" aria-label="Loading">
        <FaCog className="spinner-cog" aria-hidden="true" />
      </div>
    );
  }

  return signInModes ? <SignInModes /> : <SignInLegacy />;
};

export default SignInRoute;
